import styled, { css } from 'styled-components';
import { themeGet } from 'modules/v2/foundation/theme';
import { linkAppearance } from './utils';
const fontSize = {
    large: themeGet('fontSize.large'),
    medium: themeGet('fontSize.medium'),
    small: themeGet('fontSize.small'),
    tiny: themeGet('fontSize.tiny'),
};
const linkBase = css `
  font-size: ${(props) => fontSize[props.$size]};
  display: inline-block;
  text-decoration: none;
  cursor: pointer; /* required for <Link as="button"> */
`;
export const StyledAnchor = styled.a `
  ${linkBase};

  ${(props) => linkAppearance(props.$appearance)};
`;
